<app-dialog [showHeader]="false" [show]="show" [minWidth]="(inventoryLocationsEnabled$ | async) ? 800 : 640">
    <div class="header-container">
      <div class="flex">
        <span class="flex mr-4 cursor-pointer text-[#D3D3D3] text-[1.3rem] leading-7 font-medium" (click)="onBackHandler()">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="17" focusable="false" viewBox="0 0 12 12"
            class="mt-[4px] mr-[8px] stroke-[1.5px]">
            <path fill="none" stroke="currentColor" stroke-linecap="round"
              d="M4 3L.9 6.1c-.2.2-.2.5 0 .7L4 10M1 6.5h10.5" />
          </svg>
          <span> Back &nbsp;/</span>
        </span>
        <span class="header">Add new drug</span>
      </div>
    </div>
  
    <app-input-search-scanner 
                              [autofocus]="show"
                              [isInventory]="true"
                              [searchEmptyInventory]="false"
                              [active]="true"
                              (optionSelected)="optionSelected($event)"
                              (searchValueChanged)="handleSearchInput($event)"
                              [placeholder]="'Scan barcode (Or search drug name or NDC)'"
                              [label]="'What drug would you like to add?'"
                              [errorMessage]="errorMessage"
                              [displayError]="isError && isOptionSelected"
                              [locationsToExclude]="ndcsToExclude"
                              [singleLocationResult]="inventoryLocationsEnabled$ | async"
                              [gpi]="gpi"
                              #inputChild
    ></app-input-search-scanner>
    
    <div class="dialog-controls-default">
      <app-button text="Cancel"
                  subStyle="transparent"
                  class="cancel-btn"
                  (clicked)="close()"
                  
                  #closeButton
      >
      </app-button>

      <app-button customClasses="px-4"
                  text="Add"
                  class="save-btn"
                  [disabled]="isError"
                  type="submit"
                  #submitButton
                  (clicked)="saveDrug()"
      >
      </app-button>
    </div>
</app-dialog>  